import { validationConstants } from "constants/formValidation";
import useFormValidation from "hooks/useFormValidation";
import { Label } from "layout/typography/Label";
import { InputText } from "primereact/inputtext";
import { Controller, useFormContext } from "react-hook-form";

import {
  StyledDisclaimerTextarea,
  StyledSettingsCard,
  StyledSettingsDescription,
  StyledSettingsHeader,
} from "../styled";

const fields = [
  {
    name: "GFE-disclaimerTitleEnglish",
    label: "Disclaimer Title English",
    multiline: false,
    required: validationConstants.CUSTOMIZE_FORM.GFE_DISCLAIMER_TITLE,
  },
  {
    name: "GFE-disclaimerDescriptionEnglish",
    label: "Disclaimer Description English",
    multiline: true,
    required: validationConstants.CUSTOMIZE_FORM.GFE_DISCLAIMER_DESCRIPTION,
  },
  {
    name: "GFE-disclaimerTitleSpanish",
    label: "Disclaimer Title Spanish",
    multiline: false,
    required: validationConstants.CUSTOMIZE_FORM.GFE_DISCLAIMER_TITLE,
  },
  {
    name: "GFE-disclaimerDescriptionSpanish",
    label: "Disclaimer Description Spanish",
    multiline: true,
    required: validationConstants.CUSTOMIZE_FORM.GFE_DISCLAIMER_DESCRIPTION,
  },
];

/**
 * The disclaimer only ever appears to patients inside a modal, so it is edited
 * here as plain inputs rather than in place. The preview's modal reads these
 * same form values, so it always shows the current text.
 */
export function DisclaimerFields() {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();
  const { handleOnBlurField, getFormErrorMessage } = useFormValidation();

  return (
    <StyledSettingsCard>
      <StyledSettingsHeader>
        <i className="pi pi-file-edit" />
        DISCLAIMER CONTENT
      </StyledSettingsHeader>

      <StyledSettingsDescription>
        This text is not shown on the page itself. Patients read it in the
        disclaimer modal above — edit it here and the modal updates.
      </StyledSettingsDescription>

      <div className="flex flex-column gap-3 mt-3">
        {fields.map((field) => (
          <div className="field flex flex-column m-0" key={field.name}>
            <Label htmlFor={field.name} data-test-id={`${field.name}-label`}>
              {field.label}
            </Label>

            <Controller
              name={field.name}
              control={control}
              rules={{ required: field.required }}
              render={({ field: { onChange, onBlur, value } }) => {
                const inputProps = {
                  id: field.name,
                  autoComplete: "off",
                  value: value || "",
                  "aria-labelledby": field.name,
                  onChange,
                  onBlur: () => {
                    handleOnBlurField({ onBlur, field: field.name, trigger });
                  },
                };

                return (
                  <>
                    {field.multiline ? (
                      <StyledDisclaimerTextarea {...inputProps} rows={3} />
                    ) : (
                      <InputText {...inputProps} />
                    )}

                    {getFormErrorMessage(field.name, errors)}
                  </>
                );
              }}
            />
          </div>
        ))}
      </div>
    </StyledSettingsCard>
  );
}
